import { useSearchParams } from "react-router-dom";

const useSearch = () => {
  const [searchParams, setSearchParams] = useSearchParams({ q: "" });
  const params = Object.fromEntries([...searchParams]);
  const q = params.q;

  function setQ(newQ) {
    setSearchParams({ ...params, q: newQ });
  }

  return [q, setQ];
};

export default useSearch;
